import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './locales/de.json';
import en from './locales/en.json';
import se from './locales/se.json';
import pl from './locales/pl.json';
import cz from './locales/cz.json';

const resources = {
  de: { translation: de },
  en: { translation: en },
  se: { translation: se },
  pl: { translation: pl },
  cz: { translation: cz }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // Default language
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
